/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseNoteTemplateResponse
 */
export interface CaseNoteTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseNoteTemplateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteTemplateResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CaseNoteTemplateResponse
     */
    content: string;
}

/**
 * Check if a given object implements the CaseNoteTemplateResponse interface.
 */
export function instanceOfCaseNoteTemplateResponse(value: object): value is CaseNoteTemplateResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function CaseNoteTemplateResponseFromJSON(json: any): CaseNoteTemplateResponse {
    return CaseNoteTemplateResponseFromJSONTyped(json, false);
}

export function CaseNoteTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseNoteTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'content': json['content'],
    };
}

export function CaseNoteTemplateResponseToJSON(json: any): CaseNoteTemplateResponse {
    return CaseNoteTemplateResponseToJSONTyped(json, false);
}

export function CaseNoteTemplateResponseToJSONTyped(value?: CaseNoteTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'content': value['content'],
    };
}

